import {ThemeProvider, Hero} from '@primer/react-brand'

const extURLs = {
  sign_up: '#TODO',
  try_copilot: '#TODO',
}

export function HomeIndex() {
  return (
    <ThemeProvider colorMode="dark">
      {/* Hero */}

      <section id="hero">
        <Hero data-hpc align="center">
          <Hero.Heading size="2">Build and ship software on a single, collaborative platform</Hero.Heading>
          <Hero.Description size="300">
            Join the industry’s leading AI-powered developer platform where millions of developers, thousands of
            businesses, and the world’s largest open source community create the software that shapes our world.
          </Hero.Description>
          <Hero.PrimaryAction href={extURLs.sign_up}>Sign up</Hero.PrimaryAction>
          <Hero.SecondaryAction href={extURLs.try_copilot}>Try GitHub Copilot</Hero.SecondaryAction>
        </Hero>
      </section>
    </ThemeProvider>
  )
}

try{ HomeIndex.displayName ||= 'HomeIndex' } catch {}